<!-- 搜索结果分组 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
          <ul class="search-group-tab">
            <li v-for="tab in tabList" v-bind:class="{'total-li':tab.type==0}">{{tab.title}}<span>({{tab.infoPage.total}})</span></li>
          </ul>
          <div class="search-result-total">含“<span>{{keyWord}}</span>”的搜索结果共{{total}}条</div>
      </div>
    </div>
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoList-05 v-for="tab in tabList" v-if="tab.type>0" :showTitle="true" :infoBlock="tab.infoBlock" :infoPage="tab.infoPage" :title="tab.title" :moreLink="tab.moreLink" label="INFORMARION" count="6"/>
      </div>
      <div class="content-col col-per-30">

      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList05 from '../block/InfoList05'
import InfoBlock04 from '../block/InfoBlock04'
import InfoBlock03 from '../block/InfoBlock03'
import InfoBlock07 from '../block/InfoBlock07'
export default {
  name: 'SearchResult1',
  components: {
    'infoList-05': InfoList05,
  },
  data() {
    return {
      msg: '',
      keyWord:'',
      keyType:'',
      total:0,
      infoBlock:InfoBlock04,
      tabList:[{title:"综合",type:"0",infoBlock:InfoBlock04,infoPage:{total:0,list:[]},moreLink:''},
      {title:"资讯",type:"1",infoBlock:InfoBlock07,infoPage:{total:0,list:[]},moreLink:'/hyzx/01'},
      {title:"政策",type:"2",infoBlock:InfoBlock04,infoPage:{total:0,list:[]},moreLink:'/hyzx/03'},
      {title:"通知公告",type:"3",infoBlock:InfoBlock04,infoPage:{total:0,list:[]},moreLink:'/hyzx/04'},
      {title:"行业展会",type:"4",infoBlock:InfoBlock03,infoPage:{total:0,list:[]},moreLink:'/hyzx/05'}]
    }
  },
  methods:{
    queryPage:function(){
        let that=this;
        let result={};
        if(that.keyWord==null||that.keyWord==""||that.keyWord==undefined){
          result=that.tabList;
          that.total=0;
          result[0].infoPage.total=res.data.total;
          result[1].infoPage.total=0;
          result[1].infoPage.list=[];
          result[2].infoPage.total=0;
          result[2].infoPage.list=[];
          result[3].infoPage.total=0;
          result[3].infoPage.list=[];
          result[4].infoPage.total=0;
          result[4].infoPage.list=[];
          console.log('综合查询参数：重置查询结果');
          that.tabList=result;
        }else{
          result=that.tabList;
          let params={keywords:that.keyWord,keyType:that.keyType};
          console.log('综合查询参数：'+JSON.stringify(params));
          that.$dataApi.siteSearch(params).then(res =>{
            console.log('综合查询参数结果：'+JSON.stringify(res.data.news_list))
            that.msg=res.msg;
            that.total=res.data.total;
            result[0].infoPage.total=res.data.total;
            result[1].infoPage.total=res.data.news_list.total;
            result[1].infoPage.list=res.data.news_list.list;
            result[2].infoPage.total=res.data.policy_list.total;
            result[2].infoPage.list=res.data.policy_list.list;
            result[3].infoPage.total=res.data.notice_list.total;
            result[3].infoPage.list=res.data.notice_list.list;
            result[4].infoPage.total=res.data.expo_list.total;
            result[4].infoPage.list=res.data.expo_list.list;
            that.tabList=result;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
        }

    }
  },
  created:function(){
    this.keyWord=this.$route.query.keyWord;
    this.keyType=this.$route.query.type;
    console.log('综合查询1created：'+this.keyWord);
    this.queryPage();
  },
  watch:{
   '$route'(to,from){
      this.keyWord=this.$route.query.keyWord;
      this.keyType=this.$route.query.type;
      console.log('综合查询2watch：'+this.keyWord);
      this.queryPage();
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:4;
}

.col-per-30 {
  flex-grow:1;
}


.search-group-tab {
  dispaly:block;
  width:100%;
  height:50px;
  margin-top: 0px;
  list-style-type: none;

  //background:red;
}

.search-group-tab li {
  float: left;
  margin: 0px 4px 0px 0px;
  height: 50px;
  width: 80px;
  //color: #000;
  font-size: 12px;
  font-weight: 600;
  line-height: 50px;
  text-align: left;
  padding-left:5px;
  //background: #920E1B;
}

.total-li{
  color: var(--color6);
}

.search-group-tab li span{
  color: var(--color6);
}

.search-result-total{
  position:relative;
  height:30px;
  width:100%;
  padding-left:5px;
  text-align:left;
  font-size:12px;
  line-height:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/SearchResult1.vue